export default "__VITE_ASSET__Cwlr4A27__"